import { render, staticRenderFns } from "./ProfileTopBar.vue?vue&type=template&id=98d486c8&scoped=true&"
import script from "./ProfileTopBar.vue?vue&type=script&lang=js&"
export * from "./ProfileTopBar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTopBar.vue?vue&type=style&index=0&id=98d486c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d486c8",
  null
  
)

export default component.exports